export const STORE_SSR_DEBUG_MODE = 'STORE_SSR_DEBUG_MODE';
export const STORE_SSR_DEBUG_COOKIE = 'store-ssr-debug';
export const STORE_SSR_DEBUG_PREFIX = '[StoreSSR]';

// Full SSR response bodies must never leak into production HTML — the
// logger is a no-op everywhere except local development and the staging
// deploy tier (see NEXT_PUBLIC_ENVIRONMENT in README.md).
export const SSR_DEBUG_ALLOWED_ENVIRONMENTS = ['development', 'staging'] as const;
